import * as actionTypes from './actionTypes';
import { I_Itineraries } from './interfaces';
import dayjs from 'dayjs';

const initialState = {
    Features: '',
    UpDateTime: dayjs(new Date()).format('YYYY/MM/DD HH:mm'),
    Remark: '',
    TDHDesc: '',
    FeatureSrc: '',
    DailyList: [],
    EachTripList: [],
    OptionalInfoList: [],
    NoteList: [],
    LeaveTeamReg: '',
    SafeReg: '',
    ActiveNote: '',
    lightBoxVisible: false,
    DayID: 0,
    POIID: '',
    Name: '',
    ImgList: '',
    ImgMList: '',
    Introduction: '',
    Longtitude: 0,
    Latitude: 0,
    Address: '',
    PhoneList: [],
    WebUrl: '',
    Grade: [],
    CheckIn: '',
    CheckOut: '',
    StationInfoList: [],
    AntiepReg: '',
    ItinnotesReg: '',
};

const itinerariesReducer = (state: I_Itineraries = initialState, action: any): I_Itineraries => {
    const newState = { ...state };

    switch (action.type) {
        case actionTypes.SET_ITINERARIES_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_OPTIONALINFO_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_NOTICEINFO_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_STATIONINFO_SUCCESS:
            return { ...state, ...action.payload };
        default:
            return newState;
    }
};

export default itinerariesReducer;
